<template>
    <div class="table-aspects">
        <div class="table-aspects-title">Таблица аспектов</div>
        <div class="table-wrapper">
            <table class="aspect-table">
                <tr v-for="i in Array.from({length: rowCount + 1}, (x,i) => i)">
                    <template v-if="i == 0">
                        <th>
                            <div></div>
                        </th>
                        <th v-for="planet in planets">
                            <div>
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
                                    <PlanetIcon x="0" y="0"
                                                :planet="planet"/>
                                </svg>
                            </div>
                        </th>
                    </template>
                    <template v-else>
                        <template v-for="j in Array.from({length: planets.length + 1}, (x,i) => i)">
                            <th v-if="j == 0">
                                <div>
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                                         v-if="i < planets.length + 1">
                                        <PlanetIcon x="0" y="0"
                                                    :planet="planets[i - 1]"/>
                                    </svg>
                                    <template v-else>
                                        {{ getHouseCusp(i - planets.length - 1) }}
                                    </template>
                                </div>
                            </th>
                            <td v-else>
                                <div>
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
                                        <AspectIcon x="0" y="0"
                                                    :aspect="getAspect(i - 1, j - 1)"/>
                                    </svg>
                                </div>
                            </td>
                        </template>
                    </template>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import constants from '@/constants';
    import utils from '@/utils';
    import PlanetIcon from '@/components/icon/PlanetIcon';
    import AspectIcon from '@/components/icon/AspectIcon';

    export default {
        name: 'AspectTable',

        props: ['mode', 'planetAspects'],

        components: {
            PlanetIcon, AspectIcon
        },

        computed: {
            planets() {
                return constants.aspectPlanets;
            },

            houseCusps() {
                return constants.aspectHouseCusps;
            },

            rowCount() {
                return this.mode === constants.mode.natal ?
                        this.planets.length :
                        this.planets.length + this.houseCusps.length;
            },

            aspectTable() {
                let aspectMap = new Map();

                utils.cartesianProductOf(this.planets, this.planets)
                        .forEach(arr => {
                            if (this.mode === constants.mode.natal) {
                                /* Аспекты между планетами Натала */

                                let planet1 = arr[0];
                                let planet2 = arr[1];

                                if (planet1 === planet2)
                                    return;

                                let aspect = this.planetAspects
                                        .filter(aspect => (aspect.planet1 == planet1 && aspect.planet2 == planet2)
                                                || (aspect.planet1 == planet2 && aspect.planet2 == planet1));

                                if (aspect.length > 0) {
                                    let type = aspect[0].aspect;
                                    aspectMap.set(`${planet1}-${planet2}`, type);
                                    aspectMap.set(`${planet2}-${planet1}`, type);
                                }
                            } else {
                                /* Аспекты между планетами Натала и планетами доп.карт (Транзита/Дирекции/Прогрессии) */

                                let natalPlanet = arr[0];
                                let transitPlanet = arr[1];

                                let aspect = this.planetAspects
                                        .filter(aspect => aspect.natalPlanet == natalPlanet && aspect.transitPlanet == transitPlanet);

                                if (aspect.length > 0) {
                                    let type = aspect[0].aspect;
                                    aspectMap.set(`${natalPlanet}-${transitPlanet}`, type);
                                }
                            }
                        });

                utils.cartesianProductOf(this.houseCusps, this.planets)
                        .forEach(arr => {
                            /* Аспекты между Домами Натала и планетами доп.карт (Транзита/Дирекции/Прогрессии) */

                            let houseCusp = arr[0];
                            let transitPlanet = arr[1];

                            let aspect = this.planetAspects
                                    .filter(aspect => aspect.houseCusp == houseCusp && aspect.transitPlanet == transitPlanet);

                            if (aspect.length > 0) {
                                let type = aspect[0].aspect;
                                aspectMap.set(`${houseCusp}-${transitPlanet}`, type);
                            }
                        });

                return aspectMap;
            }
        },

        methods: {
            getHouseCusp(i) {
                return this.houseCusps[i];
            },

            getAspect(i, j) {
                let planet2 = this.planets[j];

                if (i < this.planets.length) {
                    let planet1 = this.planets[i];

                    return this.aspectTable.get(`${planet1}-${planet2}`) || null;
                } else {
                    let houseCusp = this.houseCusps[i - this.planets.length];

                    return this.aspectTable.get(`${houseCusp}-${planet2}`) || null;
                }
            }
        }
    }
</script>